export default {
  setLogged (state, payload) {
    state.logged = payload
  }
}
